module.exports = __webpack_public_path__ + "static/media/TEMPLATE8.4730fefd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE8.jpg
// module id = 1474
// module chunks = 1